import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import playlistType from 'lib/CustomPropTypes/videoPlaylist';

import Playlist from './Playlist';

import styles from './styles.module.scss';

function Playlister({ playlists }) {
  if (!playlists.length) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={styles.content}>
        <h2 className={styles.title}>{ i18next.t('Watch More') }</h2>
        <div className={styles.playlists}>
          { playlists.map((playlist) => <Playlist key={`playlist-${playlist.id}`} content={playlist} />) }
        </div>
      </div>
    </section>
  );
}

Playlister.propTypes = {
  playlists: PropTypes.arrayOf(playlistType),
};

Playlister.defaultProps = {
  playlists: [],
};

export default Playlister;
